/* eslint max-len: "off" */
export default {
    label_filter_add: 'Add filter',
    label_for_start_status_filter: 'Start Status/Commitment Point',
    label_for_end_status_filter: 'End status',
    label_ignore_saturday_sunday: 'Ignore saturday and sunday',
    label_only_included_tasks: 'The issues should have been in these statuses',
    label_for_charts_period: 'Charts period',
    label_saved_filters: 'Saved filters',
    label_confirm_delete_filter: 'Are you sure you want to remove the filter?',
    label_select_filter: 'Select report',
    label_add_new: 'Add new report',
    label_save_filter: 'Save report',
    label_edit_filter: 'Edit report "{name}"',
    label_rename_filter: 'Rename report "{name}"',
    label_query_new: 'New query',
    label_report_name: 'Report name',
    label_question_icon_only_included_tasks: 'If this option is disabled, the graph will show all issues that match the filter conditions. If the issue has not been in the "initial" status, then it will be used the date when the issue was transferred to the nearest previous status or issue`s creation date (if no such statuses are found). If the issue has not been in the "final status", then it will be used the date when the issue was transferred to the next status or the date when the issue was closed.',
};
